import { render } from "./daygrid-month.view.vue?vue&type=template&id=08c7a636&scoped=true"
import script from "./daygrid-month.view.vue?vue&type=script&lang=js"
export * from "./daygrid-month.view.vue?vue&type=script&lang=js"

import "./daygrid-month.view.vue?vue&type=style&index=0&id=08c7a636&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c7a636"]])

export default __exports__